module.exports = __webpack_public_path__ + "img/Eyesight logo.c93cbf01.svg";